export const ALL_ITEM_SHOPPING_AID = [
  {
    categry: "shoppingAids",
    itemList: [
      {
        itemSelected: "simona",
        itemName: "Simona",
        itemDescription:
          "Simona is our customized mirror. It emerges to assist our customers in various industries such as jewelers and hotels.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/shoppingAids/mirror/Desktop/700x700px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp",
          "/images/listItem/shoppingAids/mirror/Desktop/700x700px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/shoppingAids/mirror/Desktop/130x130px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp",
          "/images/listItem/shoppingAids/mirror/Desktop/130x130px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/shoppingAids/mirror/Mobile/335x335px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp",
          "/images/listItem/shoppingAids/mirror/Mobile/335x335px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/shoppingAids/mirror/Mobile/100x100px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-01.webp",
          "/images/listItem/shoppingAids/mirror/Mobile/100x100px/Lussopack-Packaging-Shopping-Aids-Mirror-Simona-02.webp",
        ],
      },
      {
        itemSelected: "simone",
        itemName: "Simone",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDescription:
          "Simone is a customized tray that helps our clients to organize their drawers along with enhancing their store appearance.",
        itemDesktopBig: [
          "/images/listItem/tray/desktop/700px/Jewelry-Trays-Simon-01.webp",
          "/images/listItem/tray/desktop/700px/Jewelry-Trays-Simon-02.webp",
          "/images/listItem/tray/desktop/700px/Jewelry-Trays-Simon-03.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/tray/desktop/130px/Jewelry-Trays-Simon-01.webp",
          "/images/listItem/tray/desktop/130px/Jewelry-Trays-Simon-02.webp",
          "/images/listItem/tray/desktop/130px/Jewelry-Trays-Simon-03.webp",
        ],
        itemMobileBig: [
          "/images/listItem/tray/mobile/335px/Jewelry-Trays-Simon-01.webp",
          "/images/listItem/tray/mobile/335px/Jewelry-Trays-Simon-02.webp",
          "/images/listItem/tray/mobile/335px/Jewelry-Trays-Simon-03.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/tray/mobile/100px/Jewelry-Trays-Simon-01.webp",
          "/images/listItem/tray/mobile/100px/Jewelry-Trays-Simon-02.webp",
          "/images/listItem/tray/mobile/100px/Jewelry-Trays-Simon-03.webp",
        ],
      },
      {
        itemSelected: "ellie",
        itemName: "Ellie",
        itemDescription:
          "Ellie is a tissue box produced by Lussopack which customers can personalize their piece by choosing their own material and color.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/ellie/desktop/700px/tissue-Boxes-Ellie.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/ellie/desktop/130px/tissue-Boxes-Ellie.webp",
        ],
        itemMobileBig: [
          "/images/listItem/ellie/mobile/335px/tissue-Boxes-Ellie.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/ellie/mobile/100px/tissue-Boxes-Ellie.webp",
        ],
      },
      {
        itemSelected: "leah",
        itemName: "Leah",
        itemDescription:
          "Leah is a tissue box produced by Lussopack which customers can personalize their piece by choosing their own material and color.",

        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/leah/desktop/700px/tissue-Boxes-Leah.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/leah/desktop/130px/tissue-Boxes-Leah.webp",
        ],
        itemMobileBig: [
          "/images/listItem/leah/Mobile/335px/tissue-Boxes-Leah.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/leah/Mobile/100px/tissue-Boxes-Leah.webp",
        ],
      },
    ],
  },
];
